import { ButtonPrimary } from "components/Atoms/Button";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { DetailSidePanel } from "../DetailSidePanel";
import { FreeFieldPermissionProfileSidePanelDetails } from "./FreeFieldPermissionProfileSidePanelDetails";

export interface FreeFieldPermissionProfileSidePanelProps {
  freeFieldPermissionProfileId: number
  environment: server.dto.Environments
  trigger: JSX.Element
}

export const FreeFieldPermissionProfileSidePanel = (props: FreeFieldPermissionProfileSidePanelProps) => {
  return <DetailSidePanel
    apiCall={() => window.CoreApi.FreeFieldProfile.GetSidePanelData(props.freeFieldPermissionProfileId)}
    apiKey="freeFieldProfile"
    entityId={props.freeFieldPermissionProfileId}
    title={RESX.FreeField.FreeFieldPermissionProfile}
    footerContent={profile => <>
      <ButtonPrimary href={routes.freeFieldProfile_Detail(profile.data.profile.environment, props.freeFieldPermissionProfileId).absolute} label={RESX.Buttons.DetailView} />
    </>}
    trigger={props.trigger}
  >
    {(data) => <FreeFieldPermissionProfileSidePanelDetails
      data={data.data}
      environment={props.environment}
    />}
  </DetailSidePanel>
}